import { render, staticRenderFns } from "./dropdown-button.component.vue?vue&type=template&id=5abbb222&scoped=true&"
import script from "./dropdown-button.component.vue?vue&type=script&lang=js&"
export * from "./dropdown-button.component.vue?vue&type=script&lang=js&"
import style0 from "./dropdown-button.component.vue?vue&type=style&index=0&id=5abbb222&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abbb222",
  null
  
)

export default component.exports